const XSS_PREFIX = 'for(;;);';

const TEXT_IN_ERROR_MESSAGE_LENGTH = 500;

export default function json() {
    return this.text().then((text) => {
        if (text.startsWith(XSS_PREFIX)) {
            text = text.substring(XSS_PREFIX.length);
        }

        try {
            return JSON.parse(text);
        } catch (e) {
            throw new Error(`Failed to parse response into JSON. URL: ${this.url}. Response: ${text.substring(0, TEXT_IN_ERROR_MESSAGE_LENGTH)}...`);
        }
    });
}
